import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/deposits'

export default {
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async setMinimumBalance(request) {
    return await axios
      .put(endpoint + '/threshold', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async suspend(request) {
    return await axios
      .put(endpoint + '/suspend', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async inquiryDeduct(request) {
    return await axios
      .post(endpoint + '/deduct/inquiry', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async inquiryRepriceDeduct(request) {
    return await axios
      .post(endpoint + '/deduct/inquiry/price', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/deposit/depositSummaryService.js